module.exports = __webpack_public_path__ + "media/images/admin/icons/video-off-34efe2271b33ca0378889333b65e86b5.svg";